module.exports = __webpack_public_path__ + "static/assets/5e25288be8a72ad0d2357b3389b711bd.svg";